// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.FormularioAlimentos_section__q8FA1{
    font-family: 'Monstserrat', sans-serif;
    background-color: #F2F4F8;   
    width: 50%;
    height: 100%;
    margin-top: 40px;
    margin-bottom: 100px;
    padding: 15px 20px;
    border-radius: 20px;
    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
    min-width: 700px;
}

.FormularioAlimentos_section__q8FA1 h2{
    color: #9E184B;
    font-size: 28px;
}

.FormularioAlimentos_section__q8FA1 h1{
    margin-top: 40px;
    font-size: 18px;
    
}

.FormularioAlimentos_section__q8FA1 td{
    font-size: 18px;
    padding-bottom: 8px;
}

.FormularioAlimentos_section__q8FA1 li{
    padding-bottom: 8px;
    text-align: left;
    display: flex;
    align-items: center;
    font-size: 18px;
}

.FormularioAlimentos_page__4WCtu{
    background-color: #EBE9E2    ;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
}



.FormularioAlimentos_enquadramento__e0Qg9{
    margin-bottom: 10%;
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 40px;
    text-align: left;
}



li{
    list-style-type: none;
}



.FormularioAlimentos_inputFalse__WDMBP{
    border: none;
    border-bottom: 1px solid rgb(0, 0, 0);
    outline: none;
    background: transparent;
    width: 50px;
    color: black;
    
}

.FormularioAlimentos_inputTrue__hEGm1{
    border: none;
    border-bottom: 1px solid rgb(172, 170, 170);
    outline: none;
    color: black;
    background: transparent;
    width: 50px;
    font-size: 16px;
}

.FormularioAlimentos_labelFalse__XfGEI{
    color: black;
}

.FormularioAlimentos_labelTrue__IVnmn{
   color: rgb(172, 170, 170);
}

.FormularioAlimentos_imagemLogoYoux__2gnQH{
    width: 146px;
    height: 47px;
    position: absolute;
}

.FormularioAlimentos_voltarProximo__\\+4ZGy{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    text-align: center;
    margin-bottom: 40px;

}

.FormularioAlimentos_inputDados__h2IUl{
    width: 65%;
    height: 45px;
}

.FormularioAlimentos_inputAlimento__\\+dw4-{
    width: 90%;
    height: 45px;
}

.FormularioAlimentos_atencao__sYVa\\+ {
    color: #9E184B;
}
`, "",{"version":3,"sources":["webpack://./src/paginas/formularios/FormularioAlimentos.module.css"],"names":[],"mappings":";AACA;IACI,sCAAsC;IACtC,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;;;AAIA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;;;AAIA;IACI,qBAAqB;AACzB;;;;AAIA;IACI,YAAY;IACZ,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,YAAY;IACZ,2CAA2C;IAC3C,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["\n.section{\n    font-family: 'Monstserrat', sans-serif;\n    background-color: #F2F4F8;   \n    width: 50%;\n    height: 100%;\n    margin-top: 40px;\n    margin-bottom: 100px;\n    padding: 15px 20px;\n    border-radius: 20px;\n    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;\n    min-width: 700px;\n}\n\n.section h2{\n    color: #9E184B;\n    font-size: 28px;\n}\n\n.section h1{\n    margin-top: 40px;\n    font-size: 18px;\n    \n}\n\n.section td{\n    font-size: 18px;\n    padding-bottom: 8px;\n}\n\n.section li{\n    padding-bottom: 8px;\n    text-align: left;\n    display: flex;\n    align-items: center;\n    font-size: 18px;\n}\n\n.page{\n    background-color: #EBE9E2    ;\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n}\n\n\n\n.enquadramento{\n    margin-bottom: 10%;\n    margin-left: 10%;\n    margin-right: 10%;\n    margin-top: 40px;\n    text-align: left;\n}\n\n\n\nli{\n    list-style-type: none;\n}\n\n\n\n.inputFalse{\n    border: none;\n    border-bottom: 1px solid rgb(0, 0, 0);\n    outline: none;\n    background: transparent;\n    width: 50px;\n    color: black;\n    \n}\n\n.inputTrue{\n    border: none;\n    border-bottom: 1px solid rgb(172, 170, 170);\n    outline: none;\n    color: black;\n    background: transparent;\n    width: 50px;\n    font-size: 16px;\n}\n\n.labelFalse{\n    color: black;\n}\n\n.labelTrue{\n   color: rgb(172, 170, 170);\n}\n\n.imagemLogoYoux{\n    width: 146px;\n    height: 47px;\n    position: absolute;\n}\n\n.voltarProximo{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    text-align: center;\n    margin-bottom: 40px;\n\n}\n\n.inputDados{\n    width: 65%;\n    height: 45px;\n}\n\n.inputAlimento{\n    width: 90%;\n    height: 45px;\n}\n\n.atencao {\n    color: #9E184B;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `FormularioAlimentos_section__q8FA1`,
	"page": `FormularioAlimentos_page__4WCtu`,
	"enquadramento": `FormularioAlimentos_enquadramento__e0Qg9`,
	"inputFalse": `FormularioAlimentos_inputFalse__WDMBP`,
	"inputTrue": `FormularioAlimentos_inputTrue__hEGm1`,
	"labelFalse": `FormularioAlimentos_labelFalse__XfGEI`,
	"labelTrue": `FormularioAlimentos_labelTrue__IVnmn`,
	"imagemLogoYoux": `FormularioAlimentos_imagemLogoYoux__2gnQH`,
	"voltarProximo": `FormularioAlimentos_voltarProximo__+4ZGy`,
	"inputDados": `FormularioAlimentos_inputDados__h2IUl`,
	"inputAlimento": `FormularioAlimentos_inputAlimento__+dw4-`,
	"atencao": `FormularioAlimentos_atencao__sYVa+`
};
export default ___CSS_LOADER_EXPORT___;
